const generateLinkParams = (url) => ({
  get: (dirtyName) => {
    if (!url || !dirtyName) return;
    const name = dirtyName.replace(/[[\]]/g, "\\$&");
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },
  getAll: () => {
    if (!url) return;
    const queryString = {};
    url.replace(
      new RegExp("([^?=&]+)(=([^&]*))?", "g"),
      function ($0, $1, $2, $3) {
        queryString[$1] = $3;
      },
    );
    return queryString;
  },
});

export { generateLinkParams };
